export default "__VITE_ASSET__DMbducOM__"